import '../scss/app.scss';

import initSubscribe from './subscribe'

document.addEventListener('DOMContentLoaded', () => {
  initSubscribe()
})
